<template>
  <teleport to="#chat-container">
    <div class="chat-panel" :style="{ display: isOpen ? 'flex' : 'none' }">
      <Slider
        :autoplay="3000"
        :items="chatGiveaways"
        item-key-prop="id"
        v-if="hasGiveawaysBanner && !isActiveTabSystem"
      >
        <template #slide="{ item }">
          <Giveaway :giveaway="item" />
          <!-- <div class="card">
            <img
              class="giveaway-image"
              :src="item.item.thumbnail"
              :alt="item.name"
            />
            <div>{{ item.name }}</div>
          </div> -->
        </template>
      </Slider>
      <div class="header">
        <div class="top">
          <div class="chat-tabs">
            <Tabs @change="changeTab" :tabs="chatTabs" />
          </div>
          <div class="user-count">
            <div class="user">
              <UserIcon />
              {{ globalConfig.data.onlineUsersCount?.toLocaleString() }}
            </div>
            <div class="arrow" @click="$emit('close')">
              <Arrow style="transform: rotate(90deg)" />
            </div>
          </div>
        </div>
      </div>
      <GlobalChat :is-open="isOpen" v-if="activeTab == 'global'" />
      <div v-show="activeTab == 'system'" :id="`tawk_${TAWK_ID}`"></div>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import chatMixin from "@/components/chat/mixins"
import Giveaway from "@/components/home/desktop/Giveaways/Giveaway.vue"

export default defineComponent({
  name: "ChatDesktop",
  mixins: [chatMixin],
  components: { Giveaway },
})
</script>

<style lang="scss" scoped>
.chat-panel {
  position: fixed;
  --webkit-overflow-scrolling: touch;
  top: var(--header-height);
  right: 10px;
  width: 336px;
  box-sizing: border-box;
  height: calc(100% - var(--header-height));
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 3;
  transition: all 0.3s ease;
  background: linear-gradient(
    135deg,
    #2d2f33 0%,
    #282a2e 51.37%,
    #212429 99.14%
  );

  @media screen and (max-width: 950px) {
    justify-content: normal;
  }

  .card {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .giveaway-image {
      width: 100px;
      height: 100px;
    }
  }
  .header {
    display: flex;
    flex-direction: column;

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      top: 69px;
      right: 15px;
      padding: 8px 16px;
      background: #212429;
      height: 48px;

      .user-count {
        display: flex;
        align-items: center;
        gap: 12px;

        .user {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 4px 8px;
          gap: 4px;
          width: 48px;
          height: 24px;
          background: rgba(255, 255, 255, 0.04);
          border-radius: 8px;
          font-family: "Montserrat";
          font-style: normal;
          font-weight: 600;
          font-size: 12px;
          line-height: 16px;
          letter-spacing: -0.4px;
          color: #ffffff;
        }
        .arrow {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 4px 8px;
          gap: 4px;
          width: 32px;
          height: 24px;
          background: rgba(255, 255, 255, 0.04);
          border-radius: 8px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
